import {IQuery} from '../../interfaces/models'
import {TypeKeyIdFeaturesPair} from '../../interfaces/reducers'
import {ICrudService, ISourceApplyEdits, ITypeFeaturesPair} from '../../interfaces/services'
import {Feature, Geometry} from '../../models'
import {FeatureLayerInfo} from '../../models/FeatureLayerInfo'

export class GisCrudService implements ICrudService {
  protected remoteGisCrudService: ICrudService
  constructor(remoteGisCrudService: ICrudService) {
    this.remoteGisCrudService = remoteGisCrudService
  }

  public updateEdits(sourceEdits: TypeKeyIdFeaturesPair): void {
    return this.remoteGisCrudService.updateEdits(sourceEdits)
  }

  public attachAttachments(typeFeaturesPair: ITypeFeaturesPair): Promise<Feature[]> {
    return this.remoteGisCrudService.attachAttachments(typeFeaturesPair)
  }

  public applyEdits(applyEdits: ISourceApplyEdits[]): Promise<ISourceApplyEdits[]> {
    return this.remoteGisCrudService.applyEdits(applyEdits)
  }

  public identify(
    featureLayerInfos: Array<FeatureLayerInfo>,
    geometry: Geometry
  ): Promise<Array<{layerInfo: FeatureLayerInfo; features: Array<Feature>}>> {
    const ordered = featureLayerInfos.sort((l1, l2) =>
      l1.sourceDescription.identifyZ - l2.sourceDescription.identifyZ > 0 ? -1 : 1
    )
    return this.remoteGisCrudService.identify(ordered, geometry)
  }

  public execute(featureLayerInfo: FeatureLayerInfo, query: IQuery): Promise<Array<Feature>> {
    return this.remoteGisCrudService.execute(featureLayerInfo, query)
  }

  public executeForCount(featureLayerInfo: FeatureLayerInfo, query: IQuery): Promise<number> {
    return this.remoteGisCrudService.executeForCount(featureLayerInfo, query)
  }

  public executeForExtent(featureLayerInfo: FeatureLayerInfo, query: IQuery & any): Promise<any> {
    return new Promise((resolve, reject) => {})
  }

  public executeForIds(featureLayerInfo: FeatureLayerInfo, query: IQuery): Promise<number[]> {
    return new Promise((resolve, reject) => {})
  }
}
